

export const tipoNeumologica = (dataSemiologia) => {
  
  const { fuma, drogas, vacunas, sintomas } = dataSemiologia;

  let textoFuma = '';
  let textoDrogas = '';
  let textoVacunas = '';
  let textoSintomas = '';

  if(fuma && fuma.active) {
    textoFuma = `empezo a fumar a los ${fuma.edadFuma} años, fuma ${fuma.nCigarrillos} cigarrillos por ${fuma.aniosFuma} años`;
  }

  if(drogas && drogas.active) {
    textoDrogas = `con consumo de drogas ( ${drogas.selected.map( droga => droga.text ).join(', ')} )`;
  }

  if(vacunas && vacunas.selected.length > 0) {
    textoVacunas = `con vacunas ( ${vacunas.selected.map( vacuna => vacuna.text ).join(', ')} )`;
  }

  if(sintomas && sintomas.selected.length > 0) {
    textoSintomas = `con sintomas ( ${sintomas.selected.map( sintoma => sintoma.text ).join(', ')} )`;
  }

  return `${textoFuma} ${textoDrogas} ${textoVacunas} ${textoSintomas}`;
}